import SearchBox from '~/components/searchBox/SearchBox.ui';

export default function Search({ toggle = false }) {
  return (
    <div className="nav--search search--header">
      <SearchBox placeholder="Buscar" toggle={toggle} />
    </div>
  )
}
